/* WHITEHOLE V171 — reliable Shopify collection filters/sorting.
 * Collection pages intentionally use normal GET navigation instead of AJAX.
 * This prevents conflicts with WHITEHOLE's virtual category renderer while
 * keeping Shopify's native filter.* and sort_by URL contract intact.
 */
(() => {
  'use strict';

  const PERSISTENT_KEYS = ['view', 'wh_category'];

  const currentUrl = () => new URL(window.location.href);

  const persistentParams = () => {
    const current = currentUrl();
    const params = new URLSearchParams();
    PERSISTENT_KEYS.forEach((key) => {
      const value = current.searchParams.get(key);
      if (value) params.set(key, value);
    });
    return params;
  };

  const appendPersistent = (params) => {
    const persistent = persistentParams();
    persistent.forEach((value, key) => params.set(key, value));
    params.delete('page');
    return params;
  };

  const navigate = (params) => {
    appendPersistent(params);
    const query = params.toString();
    const next = `${window.location.pathname}${query ? `?${query}` : ''}#ProductGridContainer`;
    window.location.assign(next);
  };

  const formParams = (form) => new URLSearchParams(new FormData(form));

  const applyFilterForm = (form) => {
    const params = formParams(form);
    // Keep the current sort when the drawer form doesn't contain it.
    if (!params.has('sort_by')) {
      const sort = currentUrl().searchParams.get('sort_by');
      if (sort) params.set('sort_by', sort);
    }
    navigate(params);
  };

  const applySortForm = (form) => {
    const params = new URLSearchParams(currentUrl().search);
    params.delete('page');
    const data = formParams(form);
    const sort = data.get('sort_by');
    if (sort) params.set('sort_by', sort);
    else params.delete('sort_by');
    navigate(params);
  };

  const preserveForLink = (href) => {
    const target = new URL(href, window.location.origin);
    const current = currentUrl();
    PERSISTENT_KEYS.forEach((key) => {
      const value = current.searchParams.get(key);
      if (value) target.searchParams.set(key, value);
    });
    if (!target.searchParams.has('sort_by') && current.searchParams.has('sort_by')) {
      target.searchParams.set('sort_by', current.searchParams.get('sort_by'));
    }
    target.searchParams.delete('page');
    target.hash = 'ProductGridContainer';
    return target.toString();
  };

  const closeDrawer = (source) => {
    const drawer = source?.closest?.('menu-drawer');
    const details = drawer?.querySelector?.(':scope > details');
    if (details) details.removeAttribute('open');
    document.documentElement.classList.remove('overflow-hidden-mobile');
    document.body.classList.remove('overflow-hidden-mobile');
  };

  document.addEventListener('click', (event) => {
    const apply = event.target.closest('[data-wh99-apply-filters]');
    if (apply) {
      const form = apply.closest('form');
      if (!form) return;
      event.preventDefault();
      event.stopPropagation();
      closeDrawer(apply);
      applyFilterForm(form);
      return;
    }

    const remove = event.target.closest('facet-remove a, .active-facets a, .mobile-facets__clear');
    if (remove && remove.href) {
      event.preventDefault();
      window.location.assign(preserveForLink(remove.href));
    }
  }, true);

  document.addEventListener('change', (event) => {
    const select = event.target.closest('select[name="sort_by"]');
    if (!select) return;
    const form = select.closest('form');
    if (!form) return;

    // Mobile/drawer sorting is applied together with the user's filter choices
    // via the Apply button. Desktop standalone sort submits immediately.
    if (form.id === 'FacetFiltersFormMobile') return;
    event.preventDefault();
    applySortForm(form);
  });

  document.addEventListener('submit', (event) => {
    const form = event.target.closest('#FacetFiltersFormMobile, #FacetFiltersForm, #FacetSortForm, #FacetSortDrawerForm, #FacetFiltersPillsForm');
    if (!form) return;
    event.preventDefault();
    if (/FacetSort/.test(form.id)) applySortForm(form);
    else applyFilterForm(form);
  }, true);

  // Progressive enhancement: if a theme/app triggers the old custom catalog
  // update event, a full navigation is not necessary here. This listener is
  // deliberately absent to keep this implementation deterministic.
})();
